var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSimpleCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 10,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3e704b",
    d: "M11.618 0c-.35.01-.68.158-.924.412-2.127 2.16-4.068 4.277-6.11 6.39l-2.4-1.95a1.33 1.33 0 00-1.89.213 1.377 1.377 0 00.21 1.915l3.36 2.723a1.33 1.33 0 001.791-.106c2.416-2.454 4.581-4.865 6.942-7.263.395-.393.512-.99.296-1.505a1.343 1.343 0 00-1.275-.828z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleCheck);
export default __webpack_public_path__ + "static/media/simple-check.dbd7cf5a.svg";
export { ForwardRef as ReactComponent };